import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Heart, Building, Briefcase, Users, Brain, Gavel, Scale } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const HomePage = () => {
  const services = [
    {
      id: 'aile-hukuku',
      title: 'Aile ve Boşanma Hukuku',
      icon: Heart,
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/s6t9buo8_aile%20hukuk.jpeg',
    },
    {
      id: 'yabancilar-hukuku',
      title: 'Yabancılar Hukuku',
      icon: Users,
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/7uqm6dj0_pasarport.jpeg',
    },
    {
      id: 'ceza-hukuku',
      title: 'Ceza Hukuku',
      icon: Gavel,
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/8jplo9lt_kelepc%CC%A7le.jpeg',
    },
    {
      id: 'sigorta-hukuku',
      title: 'Sigorta Hukuku',
      icon: Shield,
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/vv7bcg38_kaza%20car.jpeg',
    },
    {
      id: 'gayrimenkul-hukuku',
      title: 'Gayrimenkul Hukuku',
      icon: Building,
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/69umcahx_gayrimenkul.jpeg',
    },
    {
      id: 'yapay-zeka-hukuku',
      title: 'Yapay Zeka ve Bilişim Hukuku',
      icon: Brain,
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/2vd8o6t1_pexels-pixabay-270404.jpg',
    },
    {
      id: 'is-hukuku',
      title: 'İş Hukuku',
      icon: Briefcase,
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/x6u6xrsi_is%CC%A7%20hukuk.jpeg',
    },
    {
      id: 'ticaret-hukuku',
      title: 'Ticaret Hukuku',
      icon: Scale,
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/ofi6vy4q_ticaret%20hukuku.jpeg',
    },
  ];

  const testimonials = [
    {
      text: 'Avukat Zeynep Hanım işinde son derece yetkin ve özverili. Karmaşık hukuki konuları anlaşılır şekilde açıklaması, iş ve dosya takibi konusundaki titizliği, en önemlisi de arandığında rahatlıkla ulaşılabiliyor olması ile, kesinlikle fark yaratan bir avukat. Kendisine bir kez daha teşekkür ediyorum. Gönül rahatlığıyla tercih edebilirsiniz.',
    },
    {
      text: 'Zeynep Hanım\'dan aldığım avukatlık hizmetinden son derece memnun kaldım. İşyerimle ilgili yaşadığım ticari bir anlaşmazlıkta, karmaşık görünen sorunumu kısa sürede ve olumlu bir şekilde çözdü. Süreç boyunca her adımda beni bilgilendirmesi, soğukkanlı ve stratejik yaklaşımı için çok teşekkür ederim. İlgili, güven veren ve işini titizlikle yapan bir avukat. Emeğinize sağlık Zeynep hanım.',
    },
    {
      text: 'Hukuk alanında kendini çok iyi yetiştirmiş biri. Hani iyi bir dizi oyuncusu rolünü oynarken yaşar ya, Zeynep hanım da dava ile ilgili konuları konuşurken her açıdan mükemmel bakıyor. Olası senaryoları yaşarmış gibi anlatıyor. Tebrik ediyorum.',
    },
  ];

  return (
    <div 
      className="min-h-screen relative"
      style={{
        backgroundImage: 'url(https://customer-assets.emergentagent.com/job_avukat-portal-6/artifacts/rf25a184_indir.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <Navbar />

      {/* Hero Section - Exact match to reference image */}
      <section className="relative min-h-screen pt-24 flex items-center overflow-hidden">
        {/* Dark overlay - only for hero section */}
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundColor: 'rgba(0, 0, 0, 0.35)' }} />
        {/* Bottom gradient overlay behind text */}
        <div 
          className="absolute inset-0 pointer-events-none"
          style={{
            background: 'linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.35) 40%, rgba(0, 0, 0, 0.00) 100%)'
          }}
        />
        {/* Mobile Layout */}
        <div className="relative z-10 w-full flex flex-col lg:hidden items-center px-6 py-12">
          {/* Lawyer Photo - Mobile centered */}
          <div className="mb-8">
            <img
              src="https://static.wixstatic.com/media/0d73a3_1f2936b2d78c4b2f9a4c38cfafd32cda~mv2.jpg"
              alt="Avukat Zeynep Gür"
              className="w-64 h-auto object-cover rounded-lg"
            />
          </div>

          {/* Hero Text - Mobile centered */}
          <div className="text-white space-y-4 text-center">
            <p className="text-xs tracking-[0.3em] text-white font-light uppercase">HOŞ GELDİNİZ</p>
            <h1 className="text-4xl font-bold leading-tight">
              Avukat Zeynep GÜR
            </h1>
            <p className="text-base text-gray-300">Profesyonel hukuki hizmetin adresi</p>
            <div className="pt-4">
              <Link
                to="/iletisim"
                style={{ backgroundColor: '#B8935C', color: '#FFFFFF' }}
                className="inline-block hover:bg-[#a37e4a] text-white font-medium px-6 py-2.5 rounded-full shadow-lg transform hover:scale-105 transition-all duration-300"
              >
                İletişime Geç
              </Link>
            </div>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="relative z-10 w-full hidden lg:flex items-center">
          {/* Lawyer Photo - Left side, stuck to left edge, smaller */}
          <div className="flex-shrink-0">
            <img
              src="https://static.wixstatic.com/media/0d73a3_1f2936b2d78c4b2f9a4c38cfafd32cda~mv2.jpg"
              alt="Avukat Zeynep Gür"
              className="object-cover"
              style={{ width: '320px', maxWidth: '320px', height: '85vh' }}
            />
          </div>

          {/* Hero Text - Right side in remaining space */}
          <div className="flex-1 flex items-center justify-center px-12">
            <div className="text-white space-y-6 text-center max-w-2xl">
              <p className="text-sm tracking-[0.3em] text-white font-light uppercase">HOŞ GELDİNİZ</p>
              <h1 className="text-6xl lg:text-7xl font-bold leading-tight">
                Avukat Zeynep GÜR
              </h1>
              <p className="text-lg text-gray-300">Profesyonel hukuki hizmetin adresi</p>
              <div className="pt-4">
                <Link
                  to="/iletisim"
                  style={{ backgroundColor: '#B8935C', color: '#FFFFFF' }}
                  className="inline-block hover:bg-[#a37e4a] text-white font-medium px-8 py-3 rounded-full shadow-lg transform hover:scale-105 transition-all duration-300"
                >
                  İletişime Geç
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section with black blur background like services section */}
      <section className="relative py-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="backdrop-blur-md bg-black/60 p-12 rounded-lg">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-8 text-center uppercase">
              HAKKINDA
            </h2>
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed text-center">
              <p>
                İzmir Barosu'na kayıtlı Avukat Zeynep Gür, hukuk eğitiminin ardından mesleki stajını tamamlamış ve halen
                kendi bürosunda avukatlık faaliyetlerini sürdürmektedir. Mesleki çalışmalarında dürüstlük, özen, gizlilik
                ve müvekkil odaklılık ilkelerini esas almakta; bireyler ve kurumlara hukukun farklı alanlarında danışmanlık
                ve temsil hizmeti sunmaktadır.
              </p>
              <p>
                Aile hukuku, ceza hukuku, ticaret hukuku, iş hukuku, miras hukuku ve gayrimenkul hukuku başta olmak üzere
                çeşitli alanlarda hukuki süreçlerde görev almakta; güncel mevzuat ve yargı kararlarını yakından takip ederek
                müvekkillerine etkin çözümler üretmektedir.
              </p>
              <p>
                Avukat Zeynep Gür, her bir dosyaya özel ilgi ve özen göstermeyi, hukuki sürecin adil ve etkin şekilde
                yürütülmesini sağlamak için çalışmayı temel mesleki anlayış edinmiştir.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="relative py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="backdrop-blur-md bg-black/60 p-12 rounded-lg">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-12 text-center uppercase">
              HİZMETLERİMİZ
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {services.map((service) => {
                const IconComponent = service.icon;
                return (
                  <Link key={service.id} to={`/hizmetler/${service.id}`} className="h-full">
                    <Card className="bg-white/10 backdrop-blur-md border-white/20 overflow-hidden group cursor-pointer transform hover:scale-105 transition-all duration-300 hover:shadow-xl h-full flex flex-col">
                      <div className="relative h-48 overflow-hidden">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                      </div>
                      <CardContent className="p-6 flex-1 flex flex-col">
                        <h3 className="text-white font-semibold text-lg mb-2 min-h-[3.5rem] flex items-center">{service.title}</h3>
                        <p className="text-gray-300 text-sm flex items-center group-hover:translate-x-1 transition-transform duration-200 mt-auto">
                          Ayrıntılar <ArrowRight className="w-4 h-4 ml-1" />
                        </p>
                      </CardContent>
                    </Card>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="relative py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="backdrop-blur-md bg-black/60 p-12 rounded-lg">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-12 text-center uppercase">
              MÜVEKKİL GÖRÜŞLERİ
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <Card key={index} className="bg-white/10 backdrop-blur-md border-white/20">
                  <CardContent className="p-6">
                    <p className="text-white text-sm leading-relaxed italic">"{testimonial.text}"</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;